export default {
  en: {
    title: 'Sign in to {{app}}',
    body: 'Your progress, word lists and subscription — on all your devices.',
    close: 'Close',
  },
  ru: {
    title: 'Вход в {{app}}',
    body: 'Прогресс, словари и подписка — на всех твоих устройствах.',
    close: 'Закрыть',
  },
};
